"use client";

import { AnimatePresence, motion } from "motion/react";
import { useState } from "react";
import type { ArticleListing } from "../lib/we0-article-store";

export function InsightFilter({
  publishedInsights,
}: {
  publishedInsights: ArticleListing[];
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedInsight =
    publishedInsights[selectedIndex] ?? publishedInsights[0];

  return (
    <>
      {selectedInsight ? (
        <div className="insight-browser">
          <div
            className="insight-reading-list"
            role="tablist"
            aria-label="文章列表"
          >
            {publishedInsights.map((item, index) => (
              <motion.button
                aria-selected={selectedIndex === index}
                key={item.sourceArticleId}
                layout
                onClick={() => setSelectedIndex(index)}
                onFocus={() => setSelectedIndex(index)}
                onMouseEnter={() => setSelectedIndex(index)}
                role="tab"
                type="button"
              >
                <span>{String(index + 1).padStart(2, "0")}</span>
                <strong>{item.title}</strong>
              </motion.button>
            ))}
          </div>
          <div className="insight-preview">
            <AnimatePresence initial={false} mode="wait">
              <motion.figure
                animate={{ clipPath: "inset(0 0% 0 0)", scale: 1 }}
                exit={{ clipPath: "inset(0 0 0 100%)", scale: 1.02 }}
                initial={{ clipPath: "inset(0 100% 0 0)", scale: 1.02 }}
                key={selectedInsight.sourceArticleId}
                transition={{ duration: 0.24, ease: [0.22, 1, 0.36, 1] }}
              >
                {selectedInsight.coverImageUrl && (
                  <div>
                    <img
                      src={selectedInsight.coverImageUrl}
                      alt={selectedInsight.coverImageAlt ?? ""}
                    />
                  </div>
                )}
                <figcaption>
                  <span>{selectedInsight.publishedAt.slice(0, 10)}</span>
                  <strong>{selectedInsight.title}</strong>
                  <a href={`/insights/${selectedInsight.slug}`}>
                    阅读文章
                  </a>
                </figcaption>
              </motion.figure>
            </AnimatePresence>
          </div>
        </div>
      ) : (
        <p>暂无已发布的文章。</p>
      )}
    </>
  );
}
